angular.module('gym.grading').directive('gradingsTabs', function() {
  return {
    restrict: 'E',
    transclude: true,
    template: require('templates/gyms/grading/gradings_tabs.html.slim'),
    scope: {},
    controller: ["$scope", "EmploymentService", "FeatureAvailabilityService", function($scope, EmploymentService, FeatureAvailabilityService) {
      $scope.permissions = EmploymentService.get().permissions;
      $scope.isFeatureAvailable = function(feature) {
        return FeatureAvailabilityService.isAvailable(feature);
      };
      return $scope.showFeatureNotAvailableMessage = function(feature) {
        return FeatureAvailabilityService.showNotAvailableMessage(feature);
      };
    }]
  };
});
